import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Box,
  Grid2 as Grid,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  FormHelperText
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
import moment from "moment/moment";

//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../Style/dialogStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import {
  CREATE_ACADEMIC_YEAR,
  UPDATE_ACADEMIC_YEAR,
} from "../../Schema/AcademicYear";

import DatePickerForDialog from "../Include/SelecteDatePicker/DatePickerForDialog"

export default function AcademicYearForm({
  open,
  handleClose,
  setRefetch,
  dialogTitle,
  editData,
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  // console.log("editData", editData)
  // console.log("endQuater1", moment(endQuater1)?.format("YYYY-MM-DD"))

  //======================== Create User =========================
  const [createAcademicYear] = useMutation(CREATE_ACADEMIC_YEAR, {
    onCompleted: ({ createAcademicYear }) => {
      // console.log("createAcademicYear::", createAcademicYear);
      setLoading(false);
      if (createAcademicYear?.is_success === true) {
        setAlert(true, "success", createAcademicYear?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createAcademicYear?.message);
        // console.log("error....?::", createAcademicYear?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      // console.log("error::", error);
    },
  });
  //======================== Create User =========================
  const [updateAcademicYear] = useMutation(UPDATE_ACADEMIC_YEAR, {
    onCompleted: ({ updateAcademicYear }) => {
      // console.log("updateAcademicYear::", updateAcademicYear);
      setLoading(false);
      if (updateAcademicYear?.is_success === true) {
        setAlert(true, "success", updateAcademicYear?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateAcademicYear?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    academic_year: Yup.string().required(t("require")),
    end_date: Yup.string().required(t("require")),
    is_active: Yup.string(),
    start_date: Yup.string().required(t("require")),
    remark: Yup.string(),

    startQuater1: Yup.string().required(t("require")),
    endQuater1: Yup.string().required(t("require")),

    startQuater2: Yup.string().required(t("require")),
    endQuater2: Yup.string().required(t("require")),

    startQuater3: Yup.string().required(t("require")),
    endQuater3: Yup.string().required(t("require")),

    startQuater4: Yup.string().required(t("require")),
    endQuater4: Yup.string().required(t("require")),

  });

  const formik = useFormik({
    initialValues: {
      academic_year: "",
      remark: "",
      end_date: moment(),
      start_date: moment(),
      is_active: true,

      startQuater1: "",
      endQuater1: "",

      startQuater2: "",
      endQuater2: "",

      startQuater3: "",
      endQuater3: "",

      startQuater4: "",
      endQuater4: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      if (dialogTitle === "Create") {
        createAcademicYear({
          variables: {
            input: {
              academic_year: values?.academic_year,
              // is_active: true,
              remark: values?.remark,
              end_date: moment(values?.end_date)?.format("YYYY-MM-DD"),
              start_date: moment(values?.start_date)?.format("YYYY-MM-DD"),
              quarter_1: {
                end_date: moment(values?.endQuater1)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater1)?.format("YYYY-MM-DD")
              },
              quarter_2: {
                end_date: moment(values?.endQuater2)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater2)?.format("YYYY-MM-DD")
              },
              quarter_3: {
                end_date: moment(values?.endQuater3)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater3)?.format("YYYY-MM-DD")
              },
              quarter_4: {
                end_date: moment(values?.endQuater4)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater4)?.format("YYYY-MM-DD")
              }
            },
          },
        });
      } else {
        updateAcademicYear({
          variables: {
            id: editData?._id,
            input: {
              academic_year: values?.academic_year,
              // is_active: values?.is_active,
              remark: values?.remark,
              end_date: moment(values?.end_date)?.format("YYYY-MM-DD"),
              start_date: moment(values?.start_date)?.format("YYYY-MM-DD"),
              quarter_1: {
                end_date: moment(values?.endQuater1)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater1)?.format("YYYY-MM-DD")
              },
              quarter_2: {
                end_date: moment(values?.endQuater2)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater2)?.format("YYYY-MM-DD")
              },
              quarter_3: {
                end_date: moment(values?.endQuater3)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater3)?.format("YYYY-MM-DD")
              },
              quarter_4: {
                end_date: moment(values?.endQuater4)?.format("YYYY-MM-DD"),
                start_date: moment(values?.startQuater4)?.format("YYYY-MM-DD")
              }
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  useEffect(() => {
    if (dialogTitle === "Create") {
      resetForm();
    }
  }, [open]);

  useEffect(() => {
    if (editData && dialogTitle === "Update") {
      setFieldValue("academic_year", editData?.academic_year);
      setFieldValue("remark", editData?.remark);
      setFieldValue("end_date", editData?.end_date);
      setFieldValue("start_date", editData?.start_date);
      setFieldValue("is_active", editData?.is_active);

      setFieldValue("startQuater1", editData?.quarter_1?.start_date);
      setFieldValue("endQuater1", editData?.quarter_1?.end_date);

      setFieldValue("startQuater2", editData?.quarter_2?.start_date);
      setFieldValue("endQuater2", editData?.quarter_2?.end_date);

      setFieldValue("startQuater3", editData?.quarter_3?.start_date);
      setFieldValue("endQuater3", editData?.quarter_3?.end_date);

      setFieldValue("startQuater4", editData?.quarter_4?.start_date);
      setFieldValue("endQuater4", editData?.quarter_4?.end_date);
    }
  }, [editData, dialogTitle]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {dialogTitle === "Create"
                ? t("dialog_title_create_academic_year")
                : t("dialog_title_update_academic_year")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("academic_year")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder={t("academic_year")}
                  {...getFieldProps("academic_year")}
                  error={Boolean(touched.academic_year && errors.academic_year)}
                  helperText={touched.academic_year && errors.academic_year}
                />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("start_date")}
                </Typography>
                <DatePickerForDialog date={values?.start_date} setDate={(e) => setFieldValue("start_date", e)} />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("end_date")}
                </Typography>
                <DatePickerForDialog date={values?.end_date} setDate={(e) => setFieldValue("end_date", e)} />
              </Grid>
              {/* <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("thead_status")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <Select
                    value={values?.is_active}
                    onChange={(e) =>
                      setFieldValue("is_active", e.target.value)
                    }
                  >
                    <MenuItem value={true}>{t("active")}</MenuItem>
                    <MenuItem value={false}>{t("in_active")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}

              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("quater_1")}
                </Typography>
                <Divider />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("start_date")}
                </Typography>
                <DatePickerForDialog date={values?.startQuater1} setDate={(e) => setFieldValue("startQuater1", e)} />
                {!!errors.startQuater1 && touched.startQuater1 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.startQuater1}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("end_date")}
                </Typography>
                <DatePickerForDialog date={values?.endQuater1} setDate={(e) => setFieldValue("endQuater1", e)} />
                {!!errors.endQuater1 && touched.endQuater1 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.endQuater1}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("quater_2")}
                </Typography>
                <Divider />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("start_date")}
                </Typography>
                <DatePickerForDialog date={values?.startQuater2} setDate={(e) => setFieldValue("startQuater2", e)} />
                {!!errors.startQuater2 && touched.startQuater2 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.startQuater2}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("end_date")}
                </Typography>
                <DatePickerForDialog date={values?.endQuater2} setDate={(e) => setFieldValue("endQuater2", e)} />
                {!!errors.endQuater2 && touched.endQuater2 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.endQuater2}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("quater_3")}
                </Typography>
                <Divider />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("start_date")}
                </Typography>
                <DatePickerForDialog date={values?.startQuater3} setDate={(e) => setFieldValue("startQuater3", e)} />
                {!!errors.startQuater3 && touched.startQuater3 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.startQuater3}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("end_date")}
                </Typography>
                <DatePickerForDialog date={values?.endQuater3} setDate={(e) => setFieldValue("endQuater3", e)} />
                {!!errors.endQuater3 && touched.endQuater3 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.endQuater3}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("quater_4")}
                </Typography>
                <Divider />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("start_date")}
                </Typography>
                <DatePickerForDialog date={values?.startQuater4} setDate={(e) => setFieldValue("startQuater4", e)} />
                {!!errors.startQuater4 && touched.startQuater4 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.startQuater4}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("end_date")}
                </Typography>
                <DatePickerForDialog date={values?.endQuater4} setDate={(e) => setFieldValue("endQuater4", e)} />
                {!!errors.endQuater4 && touched.endQuater4 && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.endQuater4}
                  </FormHelperText>
                )}
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("remark")}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder={t("remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions>
        <Grid size={{ xs: 12 }} className="create-container">
          {loading ? (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
            >
              {t("loading")}
            </Button>
          ) : (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
              onClick={handleSubmit}
            >
              {dialogTitle === "Create" ? t("btn-create") : t("btn-update")}
            </Button>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
